import { render } from "./HeaderVideoButton.vue?vue&type=template&id=1091c1c3"
import script from "./HeaderVideoButton.vue?vue&type=script&lang=js"
export * from "./HeaderVideoButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__